/*
 *   File : delete-modal.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */
import React from "react";
import { PrimaryButton } from "../Cta";

export default function DeleteModal({ close, onClick, message, title, image }) {
  return (
    <div className=" position-fixed top-0 start-0 e-bg-modal min-h-100vh min-vw-100 d-flex align-items-center justify-content-center">
      <div className="row w-100">
        <div className="offset-4 col-lg-5">
          <div className="bg-white e-border-radius-24 p-3">
            <div className="d-flex justify-content-end">
              <PrimaryButton
                icon="close-button"
                name=""
                ClassName="bg-white"
                onPress={close}
              />
            </div>
            <div className="d-flex justify-content-center">
              <img
                src={
                  image ? image : require("../../Assets/Image/deleteModal.png")
                }
                alt="delete Modal"
                style={{ width: "200px", height: "auto" }}
              />
            </div>
            <h5 className=" text-center e-font-weight-600 e-font-20 line-height-32px e-primary-font-poppins">
              {title}
            </h5>
            <div className="row">
              <div className=" offset-1 col-10">
                <p className=" e-font-16 text-center e-font-weight-400 e-primary-font-poppins line-height-24px">
                  {message
                    ? message
                    : "Lorem ipsum dolor sit amet consectetur. Eu risus purus suspendisse leo pellentesque blandit id tellus."}
                </p>
              </div>
            </div>
            <div className="row pt-4">
              <div className="col-6">
                <PrimaryButton
                  ClassName="e-border-radius-pill e-border-1px-blue e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
                  name="Cancel"
                  onPress={close}
                />
              </div>
              <div className="col-6">
                <PrimaryButton
                  ClassName="e-border-radius-pill e-font-weight-500 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                  name="Delete"
                  onPress={onClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
